import React from 'react';
import classnames from 'classnames';
import Folder from '@mui/icons-material/Folder';

import { Checkbox } from 'uikit/inputs';
import { Typo } from 'uikit/content';

import styles from '../styles/filterOption.module.scss';

const FilterOption = ({
  isSelectable,
  isSelected,
  name,
  onChange,
  value,
}) => (
  isSelectable ? (
    <Checkbox
      className={classnames(styles.element, styles.isSelectable, {
        [styles.isSelected]: isSelected,
      })}
      id={`filter-option-${value}`}
      label={name}
      onChange={onChange}
      value={isSelected}
    />
  ) : (
    <div className={styles.element}>
      <Folder className={styles.folder} sx={{ height: 16, width: 16 }} />
      <Typo className={styles.name} element="span">{name}</Typo>
    </div>
  )
);

export default React.memo(FilterOption);
